/**
 * bb: Hauptmenue nicht zweizeilig werden lassen.
 *
 * Prestige schaltet das Menue rein ueber die Breite auf das Burger-Menue um (ab 1000px
 * ist die Leiste sichtbar). Bei langen Menues bricht sie darueber trotzdem auf zwei
 * Zeilen um. Statt einen festen Breakpoint zu raten, messen wir den tatsaechlichen
 * Umbruch: liegen die Menuepunkte nicht mehr alle auf einer Zeile, bekommt die
 * Navigation die Klasse "bb-nav-collapsed" und zeigt das Burger-Menue.
 */
(() => {
  const COLLAPSED_CLASS = 'bb-nav-collapsed';

  function sync(nav) {
    const items = nav.querySelectorAll('.header__primary-nav-item');

    if (items.length < 2) return;

    // Erst aufklappen, dann messen: sonst wuerden wir den eingeklappten Zustand messen
    // und dauerhaft zwischen beiden Varianten springen. Zwischen Entfernen und Setzen
    // der Klasse rendert der Browser nicht, es bleibt unsichtbar.
    nav.classList.remove(COLLAPSED_CLASS);

    const first = items[0];
    const last = items[items.length - 1];
    const wraps = Math.abs(last.offsetTop - first.offsetTop) > 1;

    nav.classList.toggle(COLLAPSED_CLASS, wraps);
  }

  function syncAll() {
    document.querySelectorAll('.header__primary-nav').forEach(sync);
  }

  const onResize = () => requestAnimationFrame(syncAll);

  syncAll();
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('pageshow', syncAll);

  // Webfonts aendern die Textbreite, nach dem Laden neu messen.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncAll);
  }

  // Theme-Editor: Header neu gerendert oder Menue-Einstellung geaendert.
  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('shopify:section:unload', syncAll);
})();
